/*
 * @Author: tangke
 * @Date: 2019-01-31 19:00:23
 * @Last Modified by: others
 * @Last Modified time: 2019-03-07 18:14:35
 * message页面
 */
<template>
  <div class="common-container teaVList">
    <v-navigation-drawer class="my-3 drawer-fix"
                         floating
                         permanent>
      <v-list class="d-flex pa-0">
        <template v-for="item in items">
          <v-list-tile :key="item.title"
                        class="tabs-route"
                       :class="(item.tile === paths) ? 'tab-route-active' : ''"
                       @click="turnPage(item)">
            <v-list-tile-content>
              <v-list-tile-title >{{ item.title }}
              {{item.title=='Notice'?($store.state.message.homeNoticeMsg.total>0?'(' +$store.state.message.homeNoticeMsg.total+')':''):
              (item.title=='Warning'?($store.state.message.homeWarnMsg.total>0?"("+$store.state.message.homeWarnMsg.total+")":''):
              ($store.state.message.homeRemindMsg.total>0?'('+$store.state.message.homeRemindMsg.total+')':'')
              )
              }}
          </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <router-view></router-view>
  </div>
</template>
<script>
import store from '@/store'
export default {
  data: () => ({
    
    // items title属性下注意不要带空格,不然匹配不到对应的路由
    items: [
      {
        title: 'Notice',
        number: 0,
        tile: 'notice',
        icon: 'notifications',
      },
      {
        title: 'Warning',
        number: 0,
        tile: 'warning',
        icon: 'warning',
      },
        {
        title: 'Remind',
        number: 0,
        tile: 'remind',
        icon: 'access_time',
      },
      // {
      //   title: 'Level Up',
      //   number: 0,
      //   tile: 'levelUp',
      //   icon: 'trending_up'
      // }
    ]
  }),
  computed: {
    paths: function () {
      return this.$route.fullPath.split('/').pop()
    }
  },
  methods: {
    turnPage (e) {
      this.$router.push({ path: `/message/${e.tile}` })
    }
  },

}
</script>
<style lang="scss">
// 解决过渡效果
.teaVList .v-list{
  transition:none;
 .v-list__tile__sub-title, .v-list__tile__title{
  transition:none;

}
}
</style>

